import { IMessageHandler } from "../message-handler";
import { IHandlerContext } from "../handler-context";
import { StorageMessage, StorageResponse } from "../../crypto/crypto-types";

interface GetPortfolioRequest {
  userId: string;
  password: string;
}

interface GetPortfolioResponse {
  portfolioData: Record<string, unknown> | null;
}

export class GetPortfolioHandler implements IMessageHandler<GetPortfolioRequest> {
  constructor(private context: IHandlerContext) {}

  canHandle(type: string): boolean {
    return type === "GET_PORTFOLIO";
  }

  async handle(message: StorageMessage<GetPortfolioRequest>, source: Window, origin: string): Promise<void> {
    const { userId, password } = message.data;

    if (!userId || !password) {
      this.context.sendError(source, 'Missing required data', 'MISSING_DATA', origin, message.requestId);
      return;
    }

    const userProfile = await this.context.dbService.getUserById(userId);
    if (!userProfile) {
      this.context.sendError(source, 'User not found', 'USER_NOT_FOUND', origin, message.requestId);
      return;
    }

    const sessionKey = await this.context.cryptoEngine.authenticateUser(userProfile, password);
    const encryptedData = await this.context.dbService.getPortfolio(userId);

    let portfolioData: Record<string, unknown> | null = null;
    if (encryptedData) {
      portfolioData = await this.context.cryptoEngine.decryptPortfolioData(encryptedData, sessionKey);
    }

    const response: StorageResponse<GetPortfolioResponse> = {
      type: 'RESPONSE',
      data: { portfolioData },
      requestId: message.requestId
    };
    this.context.sendResponse(source, response, origin, message.requestId);
  }
}
